export function Youtube() {
  return (
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.3301 6.06253C23.1082 4.83795 22.0511 3.94617 20.8244 3.66776C18.9886 3.27841 15.5911 3 11.9152 3C8.24142 3 4.78956 3.27841 2.95161 3.66776C1.72703 3.94617 0.667752 4.7814 0.445897 6.06253C0.221858 7.4546 0 9.40348 0 11.9092C0 14.4149 0.221858 16.3638 0.500271 17.7558C0.724309 18.9804 1.7814 19.8722 3.00598 20.1506C4.95487 20.54 8.29582 20.8184 11.9717 20.8184C15.6476 20.8184 18.9886 20.54 20.9375 20.1506C22.162 19.8722 23.2192 19.037 23.4432 17.7558C23.665 16.3638 23.9434 14.3583 24 11.9092C23.8869 9.40348 23.6085 7.4546 23.3301 6.06253ZM8.90917 15.807V8.01142L15.702 11.9092L8.90917 15.807Z" fill="currentColor"/>
</svg>

  );
}
